exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2XNED-7_3_0 {\n  color: #006ddf;\n  text-decoration: none; }\n  ._2XNED-7_3_0:hover {\n    cursor: pointer;\n    text-decoration: underline; }\n  ._6-u08-7_3_0 {\n    color: #4d4d4d; }\n    ._6-u08-7_3_0:hover {\n      color: #f47e42; }\n  ._1MBJe-7_3_0 {\n    color: #ffffff; }\n", ""]);

// Exports
exports.locals = {
	"core-link": "_2XNED-7_3_0",
	"core-link--gray": "_6-u08-7_3_0",
	"core-link--white": "_1MBJe-7_3_0"
};